import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/integration/react'

import ErrorBoundary from '#/components/ErrorBoundary'
import { LoaderProvider } from '#/contexts/Loader'
import { PageHeaderProvider } from '#/contexts/PageHeader'
import { ChartBuilderProvider } from '#/store/providers/Chartbuilder'
import { DatagridProvider } from '#/store/providers/DataGrid'
import { DataViewProvider } from '#/store/providers/DataView'
import { Localization } from '#/store/providers/Localization'
import { PageBuilderProvider } from '#/store/providers/Pagebuilder'
import { ThemeProvider } from '#/store/providers/ThemeProvider'
import { persistor, store } from '#/store/store'

// Componente Providers: Envolve a aplicação com todos os provedores necessários
export function Providers(props) {
  return (
    // O Provider do Redux fornece o estado da loja para toda a aplicação
    <Provider store={store}>
      <PersistGate persistor={persistor}>
        <ThemeProvider>
          <ErrorBoundary>
            {/* LocalizationProviderConfig envolve a aplicação com o contexto de localização */}
            <Localization>
              <LoaderProvider>
                <ChartBuilderProvider>
                  <DatagridProvider>
                    <DataViewProvider>
                      <PageBuilderProvider>
                        <PageHeaderProvider>{props.children}</PageHeaderProvider>
                      </PageBuilderProvider>
                    </DataViewProvider>
                  </DatagridProvider>
                </ChartBuilderProvider>
              </LoaderProvider>
            </Localization>
          </ErrorBoundary>
        </ThemeProvider>
      </PersistGate>
    </Provider>
  )
}
